import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import NavbarMenu from "./NavbarMenu";
import NavbarTop from "./NavbarTop";
import Menu from "./responsive/Menu";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const location = useLocation();

  return (
    <div className="my_navbar">
      <div
        className={openMenu ? "back_blur active" : "back_blur"}
        onClick={() => setOpenMenu(false)}
      ></div>

      <NavbarTop openMenu={openMenu} setOpenMenu={setOpenMenu} />

      {location.pathname === "/" && <NavbarMenu />}
      <Menu openMenu={openMenu} setOpenMenu={setOpenMenu} />
    </div>
  );
};

export default Navbar;
